import { normalizeCanvasFinishKey } from "./finishes";
import type { CanvasProductFormat } from "./types";

type FinishAsset = {
  slug: string;
  canonicalFinish: string;
};

const FINISH_ASSETS: readonly FinishAsset[] = [
  { slug: "black", canonicalFinish: "Black" },
  { slug: "light-grey", canonicalFinish: "Light Grey" },
  { slug: "structure-grey", canonicalFinish: "Structure Grey" },
  { slug: "dark-blue", canonicalFinish: "Dark Blue" },
  { slug: "ocean-grey", canonicalFinish: "Ocean Grey" },
  { slug: "light-green", canonicalFinish: "Light Green" },
  { slug: "umber", canonicalFinish: "Umber" },
  { slug: "burnt-umber", canonicalFinish: "Burnt Umber" },
  { slug: "organic-green", canonicalFinish: "Organic Green" },
  { slug: "milled-ochre", canonicalFinish: "Milled Ochre" },
  { slug: "light-oak", canonicalFinish: "Light Oak" },
  { slug: "mahogany", canonicalFinish: "Mahogany" },
  { slug: "walnut", canonicalFinish: "Walnut" },
] as const;

export const CANVAS_CANONICAL_FINISHES = FINISH_ASSETS.map((entry) => entry.canonicalFinish);

export const CANVAS_NEUTRAL_PREVIEW_IMAGE = "/catalogue-configurator/canvas/neutral/finish-unconfirmed.webp";

const CANONICAL_BY_KEY = new Map<string, FinishAsset>(
  FINISH_ASSETS.map((entry) => [normalizeCanvasFinishKey(entry.canonicalFinish), entry]),
);

function assetForFinish(finish: string | null | undefined): FinishAsset | null {
  const key = normalizeCanvasFinishKey(finish);
  return key ? CANONICAL_BY_KEY.get(key) ?? null : null;
}

export function canonicalCanvasFinishLabel(finish: string | null | undefined): string | null {
  return assetForFinish(finish)?.canonicalFinish ?? null;
}

export function resolveCanvasFinishImagePath(
  finish: string | null | undefined,
  format: CanvasProductFormat,
): string | null {
  const asset = assetForFinish(finish);
  if (!asset) return null;
  return `/catalogue-configurator/canvas/${format}/${asset.slug}.webp`;
}

export function isKnownCanvasFinish(finish: string | null | undefined): boolean {
  return Boolean(assetForFinish(finish));
}
